// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { sessionRecordingTypeLabel } from '../../../../components/sp-session-recording-type/sp-session-recording-type.enum';
import Clipboard from 'clipboard';

/** @ngInject */
export function Controller($scope, $state, SessionRecordingReportService, $filter, $translate, CompanyUser, Alert) {
    this.sessionRecordingTypeLabel = sessionRecordingTypeLabel;
    this.Alert = Alert;
    const self=this;
   
    $scope.displaySpinner = true;
    $scope.displayedItems=[];
    $scope.hstep = 1;
    $scope.mstep = 1;
    $scope.recordingTypesTranslated = [];
    self.singleSaaspassId=null;
    $scope.noAppSelected=null;
    $scope.boolFlag={successLogin: true, failLogin: true};
    $scope.timeZoneOfUser=Intl.DateTimeFormat().resolvedOptions().timeZone;

    const companyId = $state.params.companyId;
     SessionRecordingReportService.sessionRecordingReport.initialReport({companyId : companyId}, {timeZone : $scope.timeZoneOfUser}).$promise.then(function(data) {
         $scope.displaySpinner = false;
         $scope.reportData=data.reportData;
         for (var i = 0; i < $scope.reportData.length; i++) {
           $scope.reportData[i].sessionTime =  new Date($scope.reportData[i].sessionTime).toString().slice(4, 24);
         }
         $scope.filterData=data.filterData;
         $scope.filterData.recordingTypes=[];
         $scope.filterData.saaspassIDs=[];
         $scope.companyApplications=data.companyApplications;
         $scope.applicationTypes=data.applicationTypes;
         $scope.recordingTypes=data.recordingTypes;

         self.startDate=$scope.filterData.startDate;
         self.endDate=$scope.filterData.endDate;
         self.startTime=$filter('date')(self.startDate, "HH:mm:ss");
         self.endTime=$filter('date')(self.endDate, "HH:mm:ss");

         $scope.convertedDateTimeFrom  = new Date($scope.filterData.startDate).toString();
         $scope.convertedDateTimeTo  = new Date($scope.filterData.endDate).toString();

         $scope.datepickerOptions = {maxDate: new Date($scope.filterData.endDate) ,minDate:new Date(data.minDate) };
         }, function(error) {
             $scope.displaySpinner = false;
         });
    
        new Clipboard(".copyCli").on('success', () => {
            $scope.$apply(() => {
            this.Alert('success', 'global.data_copied')
            })
        })

    $scope.thumbnailUrl= function(appType) {
        var appTypeIndex=$scope.applicationTypes.findIndex((obj => obj.applicationTypeName == appType));
        var slug=$scope.applicationTypes[appTypeIndex].slug;
         return 'https://cdn.saaspass.com/apps/'+slug+'/images/thumb.png';
     }
    
    $scope.clearOldMessage = function () {
        $scope.message =null;
    }
    $scope.identifySaaspassUser= function() {
        $scope.message =null;
        CompanyUser.identifyCompanyUser({
            companyId : companyId,
            uid : encodeURIComponent(self.singleSaaspassId)
        }, function(data) {
            var member=data.saaspassUser.saaspassId;
            var index=$scope.filterData.saaspassIDs.indexOf(member);
            if( index==-1){
            $scope.filterData.saaspassIDs.push(member);
            }
        }, function(error) {
            
            if(error.status==404){
                $scope.message=$translate.instant('report_section.main.filters.search_saaspass_fail');
             } 
            else {
            $scope.message = error.data.message;}
        });
        self.singleSaaspassId=null;
    }
    $scope.clearSaaspassList = function () {
        $scope.filterData.saaspassIDs = [];
    }
    $scope.clearRecordingTypesSelection = function () {
        $scope.filterData.recordingTypes=[];
        $scope.recordingTypesTranslated=[];
    }
    $scope.changeStatusFilter=function(newValue,isSuccessFlag) {
        if(isSuccessFlag) $scope.boolFlag.successLogin=newValue; else  $scope.boolFlag.failLogin=newValue;
        if($scope.boolFlag.successLogin) {
            if($scope.boolFlag.failLogin) {
                $scope.filterData.status=null;
            } else {
                $scope.filterData.status=true;
            }
        } else {
            if($scope.boolFlag.failLogin) {
                $scope.filterData.status=false;
            } else {
                $scope.filterData.status=null;
            }
        }
    }
    
    $scope.changeSelectionRecordingType = function(member) {
        const translatedMember = $translate.instant(sessionRecordingTypeLabel(member));
        var index=$scope.filterData.recordingTypes.indexOf(member);
        if( index==-1){
            $scope.filterData.recordingTypes.push(member);
            $scope.recordingTypesTranslated.push(translatedMember);
        } else {
            $scope.filterData.recordingTypes.splice(index, 1);
            $scope.recordingTypesTranslated.splice(index,1);
        }
        
    }

    $scope.close= function($event) {
        self.opened = false;
        self.opened1 = false;
    }
    $scope.open = function($event, type) {
        $event.preventDefault();
        $event.stopPropagation();
        self.opened1=false;
        self.opened=false;
        if (type == 1) {
            self.opened = true;
            self.opened1 = false;
        } else {
            self.opened1 = true;
            self.opened = false;
        }
    };
    $scope.applyFilter=function() {
        $scope.displaySpinner = true;
        SessionRecordingReportService.sessionRecordingReportFilter.doFilter({companyId: companyId},$scope.filterData).$promise.then(function(data) {
            $scope.displaySpinner = false;
            $scope.reportData=data;
            for (var i = 0; i < $scope.reportData.length; i++) {
                $scope.reportData[i].sessionTime =  new Date($scope.reportData[i].sessionTime).toString().slice(4, 24);
            }
            $scope.displayedItems=data;

            }, function(error) {
                $scope.displaySpinner = false;
            });
        
    }
    $scope.changeDateTime = function() {
        const sDate = new Date($filter('date')(self.startDate, "yyyy-MM-dd")+' '+self.startTime);
        const eDate = new Date($filter('date')(self.endDate, "yyyy-MM-dd")+' '+self.endTime);
        $scope.filterData.startDate= sDate.getTime(); 
        $scope.filterData.endDate= eDate.getTime();
        $scope.convertedDateTimeFrom  = sDate.toString();
        $scope.convertedDateTimeTo  = eDate.toString();
    }
    
    $scope.export = {
            template: 'sessionRecordingReport',
            name: 'SAASPASS_Statistics',
            fields: ['username', 'computerName', 'saaspassId', 'applicationName', 'recordingType', 'sessionIp', 'sessionTime']
        };
}


// WEBPACK FOOTER //
// ./src/portal/states/company/reports/session-recording-report/session-recording-report.controller.js